module.exports = __webpack_public_path__ + "static/media/Logo.a4a8095c.svg";